import {GlobalConstants} from "src/app/core/constants"

export class LocalStorageHandler{
    public getUserHeaderInformation(){
        return JSON.parse(localStorage.getItem(GlobalConstants.USER_HEADING_INFORMATION) || '{}');
    }
    public getUserOrganizationInformation(){
        return JSON.parse(localStorage.getItem(GlobalConstants.USER_ORGANIZATION_INFORMATION) || '{}');
    }
    public setUserHeaderInformationFromUser(userData: any){
        
        let headerdata = {
            customerName : userData?.customerName,
            customerAddress : userData?.customerAddress,
            customerPhone : userData?.customerPhone,
            facilityName : userData?.facilityName,
            facilityId : userData?.facilityId,
            facilityAddress: userData?.facilityAddress,
            facilityPhone : userData?.facilityPhone,
            facilityList : userData?.facilityList,
            displayName : userData?.fullName,
            customerLogo : userData?.customerLogo,
            loginTime: userData?.loginTime,
            mobileNumber:userData?.mobileNo
        };
        localStorage.setItem(GlobalConstants.USER_HEADING_INFORMATION, JSON.stringify(headerdata));
    }

    public setUserOrganizationInformation(data: any)
    {
        localStorage.setItem(GlobalConstants.USER_ORGANIZATION_INFORMATION, JSON.stringify(data));
    }
    public setUserOrganizationInformationFromUser(userData: any){
        let orgData = {
            id : userData?.id,
            userName : userData?.userName,
            pwdChangeRequired: userData?.pwdChangeRequired,
            doctorNo : userData?.doctorNo,
            facilityList : userData?.facilityList,
            facilityId: userData?.facilityId,
            roleType : userData?.roleType,
        };
        localStorage.setItem(GlobalConstants.USER_ORGANIZATION_INFORMATION, JSON.stringify(orgData));
    }

    public getItem(key: string)
    {
        return localStorage.getItem(key);
    }

    public setItem(key: string, value: any)
    {
        return localStorage.setItem(key, value);
    }
}
